$("body").on("change", ".wizzy-range-for-grid", function (event) {
  handleRangeInputValueChange(event.target.value);
});
function handleRangeInputValueChange(value) {
  let x = document.querySelector(".wizzy-search-results");
  typeof x < "u" &&
    (x.classList.contains("wizzy-2-products-in-a-row") &&
      x.classList.remove("wizzy-2-products-in-a-row"),
    x.classList.contains("wizzy-3-products-in-a-row") &&
      x.classList.remove("wizzy-3-products-in-a-row"),
    x.classList.contains("wizzy-4-products-in-a-row") &&
      x.classList.remove("wizzy-4-products-in-a-row"),
    sessionStorage.setItem("wizzy-2-products-in-a-row", !1),
    sessionStorage.setItem("wizzy-3-products-in-a-row", !1),
    sessionStorage.setItem("wizzy-4-products-in-a-row", !1),
    x.classList.add("wizzy-" + value + "-products-in-a-row"),
    sessionStorage.setItem("wizzy-" + value + "-products-in-a-row", !0));
}
function toHandleComingBackFromProductPage() {
  let waitForInputToLoad = setInterval(function () {
    let CBrangeInputForGrid = document.querySelector(".wizzy-range-for-grid");
    CBrangeInputForGrid != null &&
      CBrangeInputForGrid != null &&
      (sessionStorage.getItem("wizzy-2-products-in-a-row") === "true"
        ? ((CBrangeInputForGrid.value = 2), handleRangeInputValueChange(2))
        : sessionStorage.getItem("wizzy-3-products-in-a-row") === "true"
        ? ((CBrangeInputForGrid.value = 3), handleRangeInputValueChange(3))
        : sessionStorage.getItem("wizzy-4-products-in-a-row") === "true" &&
          ((CBrangeInputForGrid.value = 4), handleRangeInputValueChange(4)),
      clearInterval(waitForInputToLoad));
  }, 1e3);
  setTimeout(function () {
    clearInterval(waitForInputToLoad);
  }, 1e4);
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $("html").removeClass("filtersOpend");
      const rangeInputForGrid = document.querySelector(".wizzy-range-for-grid");
      return (
        sessionStorage.getItem("wizzy-1-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid < "u"
          ? ((rangeInputForGrid.value = 1), handleRangeInputValueChange(1))
          : sessionStorage.getItem("wizzy-2-products-in-a-row") === "true" &&
            rangeInputForGrid != null &&
            typeof rangeInputForGrid < "u"
          ? ((rangeInputForGrid.value = 2), handleRangeInputValueChange(2))
          : sessionStorage.getItem("wizzy-3-products-in-a-row") === "true" &&
            rangeInputForGrid != null &&
            typeof rangeInputForGrid < "u" &&
            ((rangeInputForGrid.value = 3), handleRangeInputValueChange(3)),
        payload
      );
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5e3,
        mobile: 5e3,
      };
      try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 300,
            },
            {
              from: 300,
              to: 700,
            },
            {
              from: 700,
              to: 1500,
            },
            {
              from: 1500,
              to: 3500,
            },
            {
              from: 3500,
              to: 6000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5e3,
        mobile: 5e3,
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 300,
            },
            {
              from: 300,
              to: 700,
            },
            {
              from: 700,
              to: 1500,
            },
            {
              from: 1500,
              to: 3500,
            },
            {
              from: 3500,
              to: 6000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}

      return data;
    }
  );
  const colorMap = new Map([
    [
      "Multi",
      [
        "https://cdn.shopify.com/s/files/1/0636/0134/4666/files/multicolor_filter_01dd6091-6aa8-4887-97bf-1a50e81100a5.png?v=1747300683",
        !0,
      ],
    ],
    ["Brown", ["#964B00", !1]],
    ["Red", ["#FF0000", !1]],
    ["Orange", ["#FFA500", !1]],
    ["Yellow", ["#FFFF00", !1]],
    ["Green", ["#00FF00", !1]],
    ["Blue", ["#0000FF", !1]],
    ["Beige", ["#F5F5DC", !1]],
    ["Pink", ["#FFC0CB", !1]],
    ["Peach", ["#FFE5B4", !1]],
    ["Purple", ["#800080", !1]],
    ["Gold", ["#FFD700", !1]],
    ["Black", ["#000000", !1]],
    ["Grey", ["#808080", !1]],
    ["White", ["#FFFFFF", !1]],
    ["Wine", ["#990012", !1]],
    ["Silver", ["#C0C0C0", !1]],
    ["Off White", ["#F8F0E3", !1]],
    
  ]);
  function findHaxCode(key) {
    return colorMap.has(key) ? colorMap.get(key) : [key, !1];
  }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      console.log("BEFORE_RENDER_RESULTS", payload);
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        if(facets)
        {
          facets.forEach((facet) => {
            facet.key === "product_confi_color_magento" &&
              facet.data.forEach((item) => {
                let color = findHaxCode(item.key);
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
          });
        }
      }

      facets = payload.response.payload.facets;
      if(facets)
      {
        for (let i = 0; i < facets.length; i++) {
          if (facets[i].key == "sizes") {
            let sizes = facets[i].data,
              numbers = [],
              letters = [],
              newArray = new Array(),
              temp = [
                "US 0",
                "US 2",
                "US 4",
                "US 6",
                "US 8",
                "US 10",
                "US 12",
                "US 14",
                "US 16",
                "US 17",
                "US 18",
                "US 19",
                "US 20",
                "US 21",
                "S",
                "M",
                "36",
                "38",
                "40",
                "42",
                "44",
                "46",
                "48",
                "50",
                "Fabric Only",
              ];
            for (let j = 0; j < temp.length; j++) {
              for (let k = 0; k < sizes.length; k++) {
                sizes[k].key == temp[j] && newArray.push(sizes[k]);
              }
            }
            facets[i].data = newArray;
          }
        }
      }
      

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      try {
        products.forEach((product) => {

          let attr = product.attributes.filter(attr => attr.id === "product_handle");
          // console.log(product.url.searchParams);
          // console.log(attr);
          product.productHandle = attr[0].values[0].value[0];

          const url = new URL(product.url);
          url.searchParams.delete("variant");
          product.url = url.toString();
          

          const deliveryMeta = product.attributes.find(
            (item) => item.id === "product_filter_delivery_custom"
          );
          if (deliveryMeta) {
            let del = deliveryMeta.values[0].value[0];
            if (del == "Ready To Ship") {
              product.deliveryMeta = del;
            } else {
              product.deliverydayMeta = del;
            }
          }
          product.sellingPrice = product.sellingPrice.split(".")[0];
          
          const festivalMeta = product.attributes.find(
            (item) => item.id === "product_festival_stamp_magento"
          );
          
          if (festivalMeta || deliveryMeta) {
            product.hasLabel = true;
          }
          if (festivalMeta) {
            product.festivalMeta = festivalMeta.values[0].value[0];
          }
        });
      } catch (error) {}

      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log("AFTER_WIZZY_API_RESPONDED", data);
      // if(window.webengage)
      if (data.api === "search") {
            const totalCount = data?.response?.payload?.total;
            const query = data?.response?.payload?.filters?.q;
            // console.log("webengage",window.webengage);
            if (typeof totalCount === "number" && query && window.webengage) {
                window.webengage.track("Searched Product" , {
                "Source" : "Shopify",
                "Terms" : query,
                "Total Items" : totalCount
              })
              window.dataLayer = window.dataLayer || [];

              dataLayer.push([
                "event",
                "search",
                {
                  search_term: query
                }
              ]);
              // console.log("Query : ",query , typeof query);
              // console.log("totalCount : ",totalCount , typeof totalCount);
          }          
      }
      return data;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      let body = document.body;
      if (body.classList.contains("collection_header_transparent_new")) {
        body.classList.remove("collection_header_transparent_new");
      }
      if (body.classList.contains("template--bridal-collection-new")) {
        body.classList.remove("template--bridal-collection-new");
      }
      if (body.classList.contains("template--luxe-collection-new")) {
        body.classList.remove("template--luxe-collection-new");
      }
      if (body.classList.contains("bridal-wedding-dresses_page_new")) {
        body.classList.remove("bridal-wedding-dresses_page_new");
      }
      if (body.classList.contains("template--bridal-wedding-dress-new")) {
        body.classList.remove("template--bridal-wedding-dress-new");
      }
      if (body.classList.contains("page_white_header_transparent_new")) {
        body.classList.remove("page_white_header_transparent_new");
      }
      if (
        body.classList.contains("collection_hide_announcement_bar_new") &&
        body.classList.contains("collection_header_transparent_new")
      ) {
        // console.log("inside removing");
        body.classList.remove(
          "collection_hide_announcement_bar_new",
          "collection_header_transparent_new"
        );
      }

      let video = document.querySelector(".Collection_meta_banner_new");
      if (video) video.style.setProperty("display", "none", "important");
      if (window.innerWidth <= 768) {
        if (body.classList.contains("template-collection")) {
          body.classList.remove("template-collection");
        }
        if (body.classList.contains("template--luxe-collection-new")) {
          body.classList.remove("template--luxe-collection-new");
        }
        if (body.classList.contains("collection_hide_announcement_bar_new")) {
          body.classList.remove("collection_hide_announcement_bar_new");
        }
        if (body.classList.contains("collection_header_transparent_new")) {
          body.classList.remove("collection_header_transparent_new");
        }
        if (body.classList.contains("collection_full_width_new")) {
          body.classList.remove("collection_full_width_new");
        }
      }

      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      
      const swiperEls = document.querySelectorAll(".mySwiper");

      swiperEls.forEach(swiperEl => {
        if (!swiperEl.swiper && !swiperEl.classList.contains("swiper-ios")) {
          new Swiper(swiperEl, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
              nextEl: swiperEl.querySelector(".swiper-button-next"),
              prevEl: swiperEl.querySelector(".swiper-button-prev")
            },
            pagination: {
              el: swiperEl.querySelector(".swiper-pagination"),
              clickable: true
            }
          });
        }
      });
        
      let selectedPrice = document.querySelectorAll(
        ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice'] .facet-item-label-value"
      );
      selectedPrice.forEach((p) => {
        if (p) {
          // let price = p.replace(".00", "");
          // let price = p.textContent.replace(/\.0/g, "");
          let price = p.textContent.replace(/\.00/g, "");
          // console.log(price);
          let [minPrice, maxPrice] = price.split("-");
          // console.log("PRICE===========>");
           minPrice = minPrice.trim();
          // console.log(minPrice);
          minPrice.replace(".00", "");
        
            maxPrice = maxPrice.trim();
           // console.log(maxPrice);
          maxPrice.replace(".00", "");
        
            if (!minPrice.startsWith("£")) {
              minPrice = `£${minPrice}`;
            }
        
            if (!maxPrice.startsWith("£")) {
              maxPrice = `£${maxPrice}`;
        
              p.textContent = `${minPrice} - ${maxPrice}`;
            }
        }
      });

      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );

      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }

      let label = document.querySelector(".wizzy-common-select-label.mobile");
      if (label) {
        label.textContent = "Sort";
      }
      if (window.innerWidth <= 769) {
        const applyButton = document.querySelector(
          ".wizzy-common-select-options.inner button.no-js-hidden.button.button--primary"
        );
        if (applyButton) {
          applyButton.addEventListener("click", function () {
            document.body.classList.remove("wizzy-overlay-opened");
            document.body.classList.remove("wizzy-common-select-body-overlay");
            const sortButton = document.querySelector(
              ".wizzy-overlay-opened.wizzy-common-select-body-overlay .wizzy-common-select-selector"
            );
            if (sortButton) {
              sortButton.click();
            }

            const container = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container .wizzy-common-select-wrapper .wizzy-common-select-container .wizzy-common-select-options"
            );
            container.style.setProperty("display", "none", "important");
          });
        }
      }

      const original = document.querySelector(
        ".wizzy-filters-facet-block.facet-block-sizes"
      );

      if (original) {
        const targetContainer = document.querySelector(
          ".wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-filters-list-top"
        );

        if (targetContainer) {
          const existingClone = targetContainer.querySelector(
            ".wizzy-filters-facet-block.facet-block-sizes.facet-block-top"
          );

          if (!existingClone) {
            const clone = original.cloneNode(true); // true for deep clone
            clone.classList.remove("facet-block-left", "collapsed");
            clone.classList.add("facet-block-top");

            targetContainer.appendChild(clone);
          }
        }
      }
      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
      );

      filterPanel.forEach((facet) => {
        facet.addEventListener("click", function (e) {
          let currentFilter = this.closest(".wizzy-filters-facet-block");
          const isActive = currentFilter.classList.contains("collapsed");

          setTimeout(() => {
            filterPanel.forEach((h) => {
              let filter = h.closest(".wizzy-filters-facet-block");
              if (filter !== currentFilter) {
                filter.classList.add("collapsed");
              }
            });

            if (isActive) {
              currentFilter.classList.remove("collapsed");
            } else {
              currentFilter.classList.add("collapsed");
            }
          }, 100);
        });
      });
      // console.log("in view rendered");
      let ranges = document.querySelectorAll(
        ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
      );
      ranges.forEach((range) => {
        if (range.textContent.trim() === "(0)") {
          range.parentElement.remove(); 
        }
      });

      const selectedList = document.querySelector(".wizzy-selected-facet-list");
      const targetDiv1 = document.querySelector(".wizzy-facet-list-block"); 
      const targetDiv2 = document.querySelectorAll(".wizzy-facet-body"); 
      let title = document.querySelector(".applied-filters-header");
      if (selectedList && selectedList.querySelectorAll("li").length > 0) {
        // console.log("Inside divs");
        targetDiv1?.classList.add("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.add("with-selected-filters");
        });
        title?.classList.remove("remove");
      } else {
        // console.log("inside remove");
        // console.log("No selected filters");
        targetDiv1?.classList.remove("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.remove("with-selected-filters");
        });
        // console.log(title);
        title?.classList.add("remove");
        // console.log("Removed title", title);
      }
      document
        .querySelectorAll(".wizzy-grid-filters-box")
        .forEach((filterBox) => {
          const facetList = filterBox.querySelector(".wizzy-facet-list");
          const leftButton = filterBox.querySelector(".scroll-btn.left");
          const rightButton = filterBox.querySelector(".scroll-btn.right");

          if (!facetList || !leftButton || !rightButton) return;

          leftButton.addEventListener("click", () => {
            facetList.scrollBy({ left: -200, behavior: "smooth" });
          });

          rightButton.addEventListener("click", () => {
            facetList.scrollBy({ left: 200, behavior: "smooth" });
          });
        });

      const priceElements = document.querySelectorAll('.price-item--regular');
      priceElements.forEach((el) => {
        el.textContent = el.textContent.replace(/\.00\b/, '');
      });

      return data;
    }
  );
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
    if (payload.filters) {
      payload.filters.showOOSProductsInOrder = "true";
    }
    if(payload?.filters?.type === "AUTOCOMPLETE_DEFAULT")
    {
      payload?.filters?.sort?.push({
        field: "product_wizzy-best-selling_sortOrder:float",
        order: "asc"
      });
    }

    return payload;
  }
);
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      toHandleComingBackFromProductPage();
      const swiperEls = document.querySelectorAll(".mySwiper");

      swiperEls.forEach(swiperEl => {
        if (!swiperEl.classList.contains("swiper-ios")) {
          new Swiper(swiperEl, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
              nextEl: swiperEl.querySelector(".swiper-button-next"),
              prevEl: swiperEl.querySelector(".swiper-button-prev")
            },
            pagination: {
              el: swiperEl.querySelector(".swiper-pagination"),
              clickable: true
            }
          });
        }
      });
      let selectedPrice = document.querySelectorAll(
        ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice'] .facet-item-label-value"
      );
      selectedPrice.forEach((p) => {
        if (p) {
          let price = p.textContent.replace(/\.0/g, "");
          let [minPrice, maxPrice] = price.split("-");
           minPrice = minPrice.trim();
            maxPrice = maxPrice.trim();
        
            if (!minPrice.startsWith("₹")) {
              minPrice = `₹${minPrice}`;
            }
        
            if (!maxPrice.startsWith("₹")) {
              maxPrice = `₹${maxPrice}`;
            }
        
            p.textContent = `${minPrice} - ${maxPrice}`;
        }
      });

      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );

      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }

      let label = document.querySelector(".wizzy-common-select-label.mobile");
      if (label) {
        label.textContent = "Sort";
      }
      if (window.innerWidth <= 769) {
        const applyButton = document.querySelector(
          ".wizzy-common-select-options.inner button.no-js-hidden.button.button--primary"
        );
        if (applyButton) {
          applyButton.addEventListener("click", function () {
            document.body.classList.remove("wizzy-overlay-opened");
            document.body.classList.remove("wizzy-common-select-body-overlay");
            const sortButton = document.querySelector(
              ".wizzy-overlay-opened.wizzy-common-select-body-overlay .wizzy-common-select-selector"
            );
            if (sortButton) {
              sortButton.click();
            }

            const container = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container .wizzy-common-select-wrapper .wizzy-common-select-container .wizzy-common-select-options"
            );
            container.style.setProperty("display", "none", "important");
          });
        }
      }

      const original = document.querySelector(
        ".wizzy-filters-facet-block.facet-block-sizes"
      );

      if (original) {
        const targetContainer = document.querySelector(
          ".wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-filters-list-top"
        );

        if (targetContainer) {
          const existingClone = targetContainer.querySelector(
            ".wizzy-filters-facet-block.facet-block-sizes.facet-block-top"
          );

          if (!existingClone) {
            const clone = original.cloneNode(true); // true for deep clone
            clone.classList.remove("facet-block-left", "collapsed");
            clone.classList.add("facet-block-top");

            targetContainer.appendChild(clone);
          }
        }
      }
      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
      );

      filterPanel.forEach((facet) => {
        facet.addEventListener("click", function (e) {
          let currentFilter = this.closest(".wizzy-filters-facet-block");
          const isActive = currentFilter.classList.contains("collapsed");

          setTimeout(() => {
            filterPanel.forEach((h) => {
              let filter = h.closest(".wizzy-filters-facet-block");
              if (filter !== currentFilter) {
                filter.classList.add("collapsed");
              }
            });

            if (isActive) {
              currentFilter.classList.remove("collapsed");
            } else {
              currentFilter.classList.add("collapsed");
            }
          }, 100);
        });
      });
      // console.log("in view rendered");
      let ranges = document.querySelectorAll(
        ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
      );
      ranges.forEach((range) => {
        if (range.textContent.trim() === "(0)") {
          range.parentElement.remove(); // remove the parent element from the DOM
        }
      });

      const selectedList = document.querySelector(".wizzy-selected-facet-list");
      const targetDiv1 = document.querySelector(".wizzy-facet-list-block"); // Replace if needed
      const targetDiv2 = document.querySelectorAll(".wizzy-facet-body"); // Replace if needed
      let title = document.querySelector(".applied-filters-header");
      if (selectedList && selectedList.querySelectorAll("li").length > 0) {
        // console.log("Inside divs");
        targetDiv1?.classList.add("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.add("with-selected-filters");
        });
        title?.classList.remove("remove");
      } else {
        // console.log("inside remove");
        // console.log("No selected filters");
        targetDiv1?.classList.remove("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.remove("with-selected-filters");
        });
        // console.log(title);
        title?.classList.add("remove");
        // console.log("Removed title", title);
      }
      document
        .querySelectorAll(".wizzy-grid-filters-box")
        .forEach((filterBox) => {
          const facetList = filterBox.querySelector(".wizzy-facet-list");
          const leftButton = filterBox.querySelector(".scroll-btn.left");
          const rightButton = filterBox.querySelector(".scroll-btn.right");

          if (!facetList || !leftButton || !rightButton) return;

          leftButton.addEventListener("click", () => {
            facetList.scrollBy({ left: -200, behavior: "smooth" });
          });

          rightButton.addEventListener("click", () => {
            facetList.scrollBy({ left: 200, behavior: "smooth" });
          });
        });

      const priceElements = document.querySelectorAll('.price-item--regular');
      priceElements.forEach((el) => {
        el.textContent = el.textContent.replace(/\.00\b/, '');
      });
      return data;
    }
  );
};


let searchbtn = document.querySelector(".search_main_new");
searchbtn.addEventListener("click", function () {
  let searchBar = document.querySelector(".search__input");
  if (searchBar) {
    searchBar.click();
  }
});
